import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import AppLayout from './layout/AppLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Entitlements from './pages/Entitlements';
import Users from './pages/Users';
import Roles from './pages/Roles';
import Permissions from './pages/Permissions';
import UserRoles from './pages/UserRoles';
import M2MTest from './pages/M2MTest';
import M2MPublicTest from './pages/M2MPublicTest';
import KeyRotation from './pages/KeyRotation';
import PermissionSync from './pages/PermissionSync';
import TokenInspector from './pages/TokenInspector';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* Pre-auth M2M token test (client_credentials is login-independent) — sibling of /login. */}
      <Route path="/m2m-public" element={<M2MPublicTest />} />
      <Route
        element={
          <PrivateRoute>
            <AppLayout />
          </PrivateRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/entitlements" element={<Entitlements />} />
        <Route path="/users" element={<Users />} />
        <Route path="/roles" element={<Roles />} />
        <Route path="/permissions" element={<Permissions />} />
        <Route path="/user-roles" element={<UserRoles />} />
        <Route path="/m2m" element={<M2MTest />} />
        <Route path="/key-rotation" element={<KeyRotation />} />
        <Route path="/permission-sync" element={<PermissionSync />} />
        <Route path="/token-inspector" element={<TokenInspector />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;
